import { queryToString } from '@shared/helpers/api-utils';
import axios from '@shared/helpers/axios';

const apiPath = 'api/v2/care-messages';

export interface CareMessageType {
    id: number;
    careRoomId: number;
    memberId?: number;
    adminId?: number | null;
    message?: string;
    createdAt: string;
    imageUrls?: { name?: string; url?: string } | null;
    withContext?: boolean;
}

const careMessageApi = {
    index: (query: Record<string, any>) => {
        return axios.get(
            `${process.env.REACT_APP_API_URL}/${apiPath}/index?${queryToString(query)}`
        );
    },
    sendMessage: (entity: {
        message: string;
        memberId: number;
        careRoomId: number;
        imageUrls?: { name?: string; url?: string } | null;
    }) => {
        return axios.post(`${process.env.REACT_APP_API_URL}/${apiPath}/send`, {
            ...entity,
        });
    },
};

export default careMessageApi;
